// Fix: Move imports to top
import React from 'react';
import { AppProvider } from './AppContext';
import { ChatProvider } from './ChatContext';

export { AppProvider, useAppContext, ActionTypes } from './AppContext';
export { ChatProvider, useChatContext, ChatActionTypes } from './ChatContext';

// Combined provider for convenience
export const GlobalProvider = ({ children }) => {
  return (
    <AppProvider>
      <ChatProvider>
        {children}
      </ChatProvider>
    </AppProvider>
  );
};